(function () {
  // Filtering
  const cbox = document.querySelectorAll(".filterable > input[type=checkbox]");
  const allBox = document.querySelector(".document-all-contracts");
  const docRoute = "/legal-and-business-documents";
  const addCategory = document.querySelector("input[name=document_additional_category]");
  let filterParams = [];
  let timeOut;

  const initQuery = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    filterParams = urlSearchParams.getAll('category_name[]');

    if (filterParams.length > 0) {
      for (let i in filterParams) {
        document.querySelector("[data-url='" + filterParams[i] + "']").checked = true;
      };

      allBox.checked = false;
    };

    if (addCategory.value) {
      const urlCheckbox = document.querySelector("[data-url='" + addCategory.value + "']");
      if (urlCheckbox) {
        urlCheckbox.checked = true;
        allBox.checked = false;
      };
    };
  }
  initQuery();

  const showOverlay = () => {
    document.querySelector(".filter-overlay-body").style.display = 'block';
    document.querySelector(".filter-overlay-text").style.display = 'block';
  };

  const filterQuery = () => {
    let parameters = [];
    filterParams = filterParams.filter((v, i, a) => a.indexOf(v) == i);
    for (let property in filterParams) {
      parameters.push(encodeURI('category_name[]=' + filterParams[property]));
    };
    allBox.checked = false;

    if (parameters.length >= 0) {
      showOverlay();
      timeOut = setTimeout(function () {
        if (parameters.length == 1) {
          const url = window.location.origin + docRoute + '/' + filterParams[0];

          window.location.href = url + "?" + parameters.join('&');
        } else {
          window.location.href = window.location.origin + docRoute + "?" + parameters.join('&');
        }
      }, 1000);
    }
  };

  const addToFilter = (value) => {
    filterParams.push(value);
  }

  const removeFromFilter = (value) => {
    filterParams = filterParams.filter(item => item !== value)
  }

  for (let i = 0; i < cbox.length; i++) {
    cbox[i].addEventListener("click", function () {
      clearTimeout(timeOut);
      if (this.checked) {
        addToFilter(this.getAttribute('data-url'));
      } else {
        removeFromFilter(this.getAttribute('data-url'));
      }
      filterQuery();
    });
  };

  allBox.addEventListener("click", function () {
    showOverlay();
    window.location.href = "/legal-and-business-documents";
  });

// Sorting
  const sortDropdowns = document.querySelectorAll(".documents-sorting .dropdown-item");
  const sortForm = document.querySelector(".document-sorting-form");

  const switchSortingTitle = (value) => {
    switch (value) {
      case 'title':
        return 'Document Name';
      case 'position':
        return 'Most downloaded';
      default:
        return 'Most downloaded';
    };
  };

  const initSorting = () => {
    const input = document.querySelector(".document-sorting-form .dropdown-toggle input");
    const span = document.querySelector(".document-sorting-form .dropdown-toggle span");
    span.innerHTML = switchSortingTitle(input.value);
  };
  initSorting();

  if (sortDropdowns) {
    sortDropdowns.forEach(link => {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = 'sort';
        hiddenField.value = this.getAttribute('data-href');

        showOverlay();
        sortForm.appendChild(hiddenField);
        sortForm.submit();
      });
    });
  }

  const MAX_HEIGHT = 30;
  // init pills by size
  const initPills = () => {
    const categories = document.querySelectorAll(".categories");
    let counter = 0;

    const checkCatHeight = (category) => {
      if (category.offsetHeight > MAX_HEIGHT) {
        const pills = category.querySelectorAll(".document-category");
        const pillCount = pills.length;

        pills[pillCount-1].remove();
        counter++;
      }
    };

    for (let i = 0; i < categories.length; i++) {
      while (categories[i].offsetHeight > MAX_HEIGHT) {
        checkCatHeight(categories[i]);
      };
      if (counter > 0) {
        const pill = categories[i].querySelector(".document-category");
        const counterPill = pill.cloneNode(true);
        counterPill.classList.add('additional');
        counterPill.querySelector('span').innerHTML = '+' + counter;
        categories[i].appendChild(counterPill);
        if (categories[i].offsetHeight > MAX_HEIGHT) {
          counter++;
          const second = categories[i].querySelector(".object-1");
          const additional = categories[i].querySelector(".additional");
          if (second) {
            second.remove();
            if (additional) {
              additional.querySelector('span').innerHTML = '+' + counter;
            }
          };
        }
        counter = 0;
      }
    };
  };
  initPills();

  const toggleFilters = () => {
    const toggleButton = document.getElementById("filter-toggle");

    toggleButton.addEventListener('click', function () {
      if (toggleButton.classList.contains('collapsed')) {
        toggleButton.innerHTML = 'Hide document filters';
      } else {
        toggleButton.innerHTML = 'Show document filters';
      }
    });
  };
  toggleFilters();
})();
